import type { ListCategory, ListCategoryWithExternalDescription, ListTemplateCategory } from '../client/types';

export const getCategoryExternalTemplate = (
    category: ListCategory | null | undefined,
    templates?: ListTemplateCategory[],
): ListTemplateCategory | null => templates?.find(template => template.id === category?.templateId && template.externalLink) ?? null;

export const addUnlinkedExternalTemplateCategories = (
    categories: ListCategory[],
    templates?: ListTemplateCategory[],
): ListCategoryWithExternalDescription[] => {
    const templateIds = new Set(categories.flatMap(category => (category.templateId ? [category.templateId] : [])));
    const externalCategories = (templates ?? [])
        .filter(template => template.externalLink && !templateIds.has(template.id))
        .map(template => ({
            ...template,
            __typename: 'Category' as const,
            parentId: null,
            templateId: template.id,
            questProgressTotal: 0,
            questProgressCompleted: 0,
            achievementProgressTotal: 0,
            achievementProgressCompleted: 0,
            externalLink: template.externalLink ?? undefined,
            externalDescription: template.externalDescription ?? undefined,
        }));
    return [...categories, ...externalCategories];
};
